import React from "react";

export default function Footer() {
  return (
    <footer>
      <a href="https://github.com/AkilaNW/weather-react.git">
        Open source code
      </a>
      <span> by Akila Wetherill</span>
    </footer>
  );
}